import React from 'react';
import HoratioEmbed from './horatioEmbed';






const MainPresenter: React.FC = () => {
  return (
    <div>
      <HoratioEmbed src="https://aistudiohost.com/?exacc=6283a2e9-0d95-4a09-961c-39eb9514b81e" />
    </div>
  );
};

export default MainPresenter;
